import React from "react";
import FaqSection from "components/FaqSection";
import GuideSection from "components/GuideSection";
import Link from "next/link";
import SideBar from "./SideBar";
import {
  HeaderH2,
  HeaderH1,
  Text,
  NextButton,
  ImageBlock,
} from "components/TextBlocks";
import Image from "next/image";

function Categories(props) {
  const keyCss = {
    fontSize: "1rem",
    fontFamily: "menlo, consolas, monospace",
    border: "1px solid #DDDDDD",
    borderRadius: "5px",
    boxShadow: "0 4px 8px -1px rgba(201,204,208,0.90)",
    backgroundColor: "#FFF",
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "7px",
    paddingRight: "6px",
  };
  return (
    <>
      <HeaderH1>Categories</HeaderH1>
      <Text>
        Categories help you organize groups into different sections. To edit
        categories go to the settings menu in the right-hand corner of the
        overview and select edit categories.{" "}
      </Text>
      <ImageBlock
        src={"/guide/edit_categories.png"}
        width={504}
        height={508}
        alt={"Change categories"}
      />
      <Text>
        You can also open the Categories modal by clicking and holding down on
        any category name for 0,4 seconds.
      </Text>
      <ImageBlock
        src={"/guide/open_categories_modal.png"}
        width={655}
        height={98}
        alt={"Change categories"}
      />
      <Text>
        Once in the modal, you can change name, delete, and move the position of
        categories. You can also create new categories by tapping the plus(+).{" "}
      </Text>
      <ImageBlock
        src={"/guide/categories_modal.png"}
        width={504}
        height={545}
        alt={"Change categories"}
      />
      <NextButton
        cta={"Share categories"}
        textColor={"#565D65"}
        bg={"#EBECED"}
        page={"/guide/share-categories"}
      />
    </>
  );
}

Categories.Layout = SideBar;

export default Categories;
